import { Table } from '@material-ui/core'
import { DadosComercialSaida } from 'models/Viabilidade/ComercialSaida'
import NumberFormat from 'react-number-format'
import { TableContainerCustomizado, TableCellLabel, TableRowCinza, TableCellValor } from '../index.style'

const CartaoComercial: React.FC<{ dados: DadosComercialSaida }> = ({ dados }) => {
  const formatarDescontoItbiRegistro = (): string | number => {
    return dados?.valorDescontoItbiRegistro ? (dados.valorDescontoItbiRegistro as number) * 100 : '-'
  }

  return (
    <TableContainerCustomizado>
      <Table data-cy="tableComercial">
        <TableRowCinza>
          <TableCellLabel>Desconto ITBI/Registro (%)</TableCellLabel>
          <TableCellValor data-cy="campoDescontoItbiRegistro">
            <NumberFormat
              value={formatarDescontoItbiRegistro()}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              suffix="%"
              allowEmptyFormatting={true}
              defaultValue="-"
              decimalScale={2}
              fixedDecimalScale={true}
            ></NumberFormat>
          </TableCellValor>
        </TableRowCinza>
        <TableRowCinza>
          <TableCellLabel>Desconto Bom Pagador (R$)</TableCellLabel>
          <TableCellValor data-cy="campoDescontoBomPagador">
            <NumberFormat
              value={dados?.descontoBomPagador}
              displayType="text"
              thousandSeparator="."
              decimalSeparator=","
              allowEmptyFormatting={true}
              defaultValue="-"
            ></NumberFormat>
          </TableCellValor>
        </TableRowCinza>
        <TableRowCinza>
          <TableCellLabel>Parcelamento (meses)</TableCellLabel>
          <TableCellValor data-cy="campoParcelamento">
            <NumberFormat value={dados?.parcelamento} displayType="text" allowEmptyFormatting={true} defaultValue="-"></NumberFormat>
          </TableCellValor>
        </TableRowCinza>
      </Table>
    </TableContainerCustomizado>
  )
}

export default CartaoComercial
